<template>
    <div class="__l">
        <h1 class="title">FAQ Categories</h1>
        <div class="actions right text-right">
            <button class="btn-primary" type="button" @click="createCategory">Create Category</button>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Category" @keyup.enter="handleSearch">

        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="70%">Title</div>
                <div class="results-head" data-width="20%"></div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell truncate" data-width="70%">{{ result.name }}</div>
                    <div class="results-cell" data-width="10%">
                        <button class="btn-tertiary muted text-center" type="button"
                                @click="handleSelectedCategory(result.id)">Edit
                        </button>
                    </div>
                    <div class="results-cell" data-width="10%">
                        <button class="btn-primary muted text-center" type="button"
                                @click="handleListArticlesInCategory(result.id)">View Articles
                        </button>
                    </div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25"
                            @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import FAQCategoriesView from './View'
import Pagination from 'v-pagination-3'

export default {
    name: 'FAQCategories',
    props: {
        //
    },
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination,
        FAQCategoriesView,
    },
    mounted() {
        if (!this.$root.persist.articlesSearch) {
            window.setTimeout(function () {
                this.$refs.searchbar.focus()
            }.bind(this), 100)
        } else {
            this.handleSearch()
        }

        window.setTimeout(function () {
            this.$refs.searchbar.focus()
        }.bind(this), 100)

        this.setMetaTitle('List FAQ Categories | JournoLink Control')

        this.loadData()
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('faq.categories.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of an Category
         *
         * @param  {Object}
         * @return {void}
         */
        handleSelectedCategory(categoryId) {
            this.$router.push({name: 'faq.categories.show', params: {categoryId: categoryId}})
        },
        /**
         * View permissions with this user
         */
        handleListArticlesInCategory(categoryId) {
            this.$root.persist.articlesSearch = "category:" + categoryId
            this.$router.push({name: 'faq.list', params: {categoryId: categoryId}})
        },
        /**
         * Create a new Category
         *
         * @return {void}
         */
        createCategory() {
            this.$router.push({name: 'faq.categories.create'})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'faq.categories.list') {
            this.setMetaTitle('List FAQ Categories | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newCategory) {
            window.setTimeout(() => {
                this.handleSelectedCategory(to.params.newCategory)
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less" scoped>
.results-list {
    button {
        width: 100%;
        padding: 0.25rem 0.75rem;
    }
}
</style>
